import Modal from '@/ui/Modal';
import LoginForm from '@/ui/Auth/LoginForm';
import RegisterForm from '@/ui/Auth/RegisterForm';
import Button from '@/ui/Button';
import Image from '@/ui/Image';
import logo from './marusa-black.webp';
// Стили
import './AuthModal.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AuthModal = function AuthModal(_ref) {
    var view = _ref.view, onChangeView = _ref.onChangeView, onClose = _ref.onClose;
    var isOpen = view !== null;
    if (!isOpen)
        return null;
    var handleClose = function handleClose() {
        onChangeView(null);
        onClose();
    };
    var handleToggleClick = function handleToggleClick() {
        if (view === 'login') {
            onChangeView('register');
        }
        else if (view === 'register') {
            onChangeView('login');
        }
        else if (view === 'register-success') {
            onChangeView('login');
        }
    };
    var toggleLabel = view === 'login' ? 'Регистрация' : view === 'register' ? 'У меня есть пароль' : view === 'register-success' ? 'Войти' : '';
    return /*#__PURE__*/ _jsxs(Modal, {
        isOpen: isOpen,
        onClose: handleClose,
        modalClassName: "auth-modal",
        children: [/*#__PURE__*/ _jsx(Image, {
                src: logo,
                alt: "logotip",
                width: "156",
                height: "35",
                className: "auth-modal__logotip"
            }), view === 'login' && /*#__PURE__*/ _jsx(LoginForm, {
                onSuccess: handleClose
            }), view === 'register' && /*#__PURE__*/ _jsx(RegisterForm, {
                onSuccess: function onSuccess() {
                    return onChangeView('register-success');
                }
            }), view === 'register-success' && /*#__PURE__*/ _jsxs("div", {
                children: [/*#__PURE__*/ _jsx("h2", {
                        children: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u043F\u0440\u043E\u0448\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E"
                    }), /*#__PURE__*/ _jsx("p", {
                        children: "\u0422\u0435\u043F\u0435\u0440\u044C \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0432\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442."
                    })]
            }), toggleLabel && /*#__PURE__*/ _jsx("div", {
                className: "auth-modal__footer",
                children: /*#__PURE__*/ _jsx(Button, {
                    variant: "ghost",
                    type: "button",
                    onClick: handleToggleClick,
                    className: "auth-modal__btn",
                    children: toggleLabel
                })
            })]
    });
};
export default AuthModal;
